import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, setCompany } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data.user);
        const me = await api.get("/auth/me");
        setCompany(me.data.company);
        window.history.replaceState(null, "", "/dashboard");
        navigate(me.data.company && !me.data.company.onboarding_complete ? "/onboarding" : "/dashboard", { state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [location.hash, navigate, setUser, setCompany]);

  return (
    <div className="flex h-screen items-center justify-center bg-slate-50">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-sky-500" />
    </div>
  );
}
